import exceptionEmailParser, { exceptionsMessages } from './ExceptionEmailParser'

export default exceptionEmailParser
export { exceptionsMessages }
